import { CloseOutlined, DownOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Space, Tag, Typography } from "antd"
import { FC } from "react"
import "./index.less"

interface Props {
  filters: { [key: string]: string | boolean | string[] } | { [key: string]: string | number | object }
  setFilters: (filters: { [key: string]: string | boolean | string[] }) => void
}

export const StatusFilter: FC<Props> = (props: Props) => {
  const { filters, setFilters } = props
  const selectedStatus = (filters.selectedStatus as string[]) || []

  const statusOptions = ["All", "Active", "Inactive", "Blocked"].map((label, index) => ({ label, key: index + 1 }))

  return (
    <Dropdown
      className={`status-filter ${!selectedStatus.length || (!selectedStatus.includes("All") && "active")}`}
      trigger={["click"]}
      overlay={
        <Menu
          onClick={e => {
            const clickedItem = statusOptions.find(item => String(item.key) === e.key)
            const clickedLabel = clickedItem?.label

            if (!clickedLabel) return

            let nextStatus: string[]

            if (clickedLabel === "All") {
              if (selectedStatus.includes("All")) {
                nextStatus = []
              } else {
                nextStatus = ["All"]
              }
            } else {
              const cleanStatus = selectedStatus.filter(status => status !== "All")

              if (cleanStatus.includes(clickedLabel)) {
                nextStatus = cleanStatus.filter(status => status !== clickedLabel)
              } else {
                nextStatus = [...cleanStatus, clickedLabel]
              }
            }

            setFilters({ ...filters, selectedStatus: nextStatus })
          }}
          selectedKeys={statusOptions
            .filter(item => (filters.selectedStatus as string[])?.includes(item.label))
            .map(item => String(item.key))}
        >
          {statusOptions.map(item => {
            const isSelected = selectedStatus.includes(item.label) || (item.label === "All" && !selectedStatus.length)

            return (
              <Menu.Item key={item.key}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>{item.label}</span>
                  <span style={{ fontWeight: "bold" }}>{isSelected && "✔"}</span>
                </div>
              </Menu.Item>
            )
          })}
        </Menu>
      }
    >
      <Typography.Link style={{ textDecoration: "none" }}>
        <Space className={"dropdown"}>
          {selectedStatus.length ? (
            selectedStatus.map(s => {
              if (s === "All")
                return (
                  <span key={s} style={{ color: "#1d1d1d" }}>
                    {s}
                  </span>
                )

              // const tagColors: Record<string, { bg: string; text: string }> = {
              //   Active: { text: "#e6f4ff", bg: "#2bb350" },
              //   Inactive: { text: "#f5f5f5", bg: "#F6DE05" },
              //   Blocked: { bg: "#fff1f0", text: "#cf1322" },
              // }

              const currentStyle = { bg: "#f5f5f5", text: "#595959" }

              return (
                <Tag
                  key={s}
                  closable
                  closeIcon={
                    <CloseOutlined
                      style={{
                        fontSize: "10px",
                        color: currentStyle.text,
                        opacity: 0.6,
                        marginLeft: "4px",
                        transition: "opacity 0.2s, transform 0.2s",
                      }}
                    />
                  }
                  onClose={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    const nextStatus = selectedStatus.filter(status => status !== s)
                    setFilters({ ...filters, selectedStatus: nextStatus })
                  }}
                  style={{
                    margin: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: currentStyle.bg,
                    color: currentStyle.text,
                    border: "none",
                    borderRadius: "4px",
                    padding: "2px 8px",
                    fontSize: "13px",
                    fontWeight: 600,
                  }}
                >
                  {s}
                </Tag>
              )
            })
          ) : (
            <span>All</span>
          )}
          <DownOutlined style={{ color: "black" }} />
        </Space>
      </Typography.Link>
    </Dropdown>
  )
}
